<script setup>
import { useToast, useConfirm, useDialog } from 'primevue'
import { notification } from '@/js/services/notification'
import { defineAsyncComponent, onMounted, ref } from 'vue'

notification.toast = useToast()
notification.confirm = useConfirm()
notification.dialog = useDialog()

notification.modal = (component, options) => {
  notification.dialog.open(
    defineAsyncComponent(() => import(`./${component}.vue`)),
    {
      ...options,
      props: { modal: true, dismissableMask: true, ...options.props },
    }
  )
}

const element = document.getElementById('vue-messages')
const messages = JSON.parse(element.textContent)
element.remove()

onMounted(() => {
  messages?.forEach((message) => {
    notification.toast.add({
      severity: message.type,
      summary: message.message,
      life: 3000,
      // detail: message.message,
    })
  })
})
</script>

<template>
  <Toast position="top-center" style="z-index: 100" />
  <ConfirmDialog></ConfirmDialog>
  <DynamicDialog />

  <Transition name="fade">
    <div id="loader" v-if="notification.loading.value">
      <ProgressSpinner />
    </div>
  </Transition>
</template>
